"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageOpportunityCommandType = exports.CoverageOpportunityCommandStatusReason = exports.CoverageOpportunityCommandStatus = void 0;
var CoverageOpportunityCommandStatus;
(function (CoverageOpportunityCommandStatus) {
    CoverageOpportunityCommandStatus["PENDING"] = "PENDING";
    CoverageOpportunityCommandStatus["COMPLETED"] = "COMPLETED";
})(CoverageOpportunityCommandStatus = exports.CoverageOpportunityCommandStatus || (exports.CoverageOpportunityCommandStatus = {}));
var CoverageOpportunityCommandStatusReason;
(function (CoverageOpportunityCommandStatusReason) {
    CoverageOpportunityCommandStatusReason["FAILED"] = "FAILED";
    CoverageOpportunityCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
})(CoverageOpportunityCommandStatusReason = exports.CoverageOpportunityCommandStatusReason || (exports.CoverageOpportunityCommandStatusReason = {}));
var CoverageOpportunityCommandType;
(function (CoverageOpportunityCommandType) {
    CoverageOpportunityCommandType["ALIGN_TO_PROSPECT"] = "ALIGN_TO_PROSPECT";
    CoverageOpportunityCommandType["ARCHIVE"] = "ARCHIVE";
    CoverageOpportunityCommandType["CHANGE_ACCOUNT"] = "CHANGE_ACCOUNT";
    CoverageOpportunityCommandType["CLOSE_TO_CLIENT"] = "CLOSE_TO_CLIENT";
    CoverageOpportunityCommandType["CONFIRM_CONTACT"] = "CONFIRM_CONTACT";
    CoverageOpportunityCommandType["CREATE"] = "CREATE";
    CoverageOpportunityCommandType["EXECUTE"] = "EXECUTE";
    CoverageOpportunityCommandType["INITIATE"] = "INITIATE";
    CoverageOpportunityCommandType["QUALIFY"] = "QUALIFY";
    CoverageOpportunityCommandType["RESET_TO_LEAD"] = "RESET_TO_LEAD";
    CoverageOpportunityCommandType["SYNC_POLICY"] = "SYNC_POLICY";
    CoverageOpportunityCommandType["SYNC_QUOTING_PLAN"] = "SYNC_QUOTING_PLAN";
    CoverageOpportunityCommandType["UNARCHIVE"] = "UNARCHIVE";
    CoverageOpportunityCommandType["UPDATE_HISTORICAL_COVERAGE"] = "UPDATE_HISTORICAL_COVERAGE";
    CoverageOpportunityCommandType["UPDATE_REQUESTED_COVERAGE"] = "UPDATE_REQUESTED_COVERAGE";
})(CoverageOpportunityCommandType = exports.CoverageOpportunityCommandType || (exports.CoverageOpportunityCommandType = {}));
//# sourceMappingURL=coverage-opportunity-command.js.map